import React from 'react'
import {
  List,
  Datagrid,
  DateField,
  DateTimeInput,
  TextField,
  SearchInput,
  SimpleForm,
  Edit,
  Create,
  ReferenceField,
  AutocompleteInput,
  ReferenceInput,
  Filter,
  CardActions,
  CreateButton,
  ExportButton,
  required,
  DateInput,
  ListButton,
  TextInput
} from 'react-admin'

import GeneratePromoCodesAction from './actions/GeneratePromoCodesAction'

const ListActions = ({ basePath, filters, data, resource, showFilter, displayedFilters, filterValues, currentSort }) => (
  <CardActions>
    {filters && React.cloneElement(filters, {
      resource,
      showFilter,
      displayedFilters,
      filterValues,
      context: 'button'
    }) }
    <CreateButton basePath={basePath} />
    <ExportButton
      resource={resource}
      sort={currentSort}
      filter={filterValues}
    />
    <GeneratePromoCodesAction record={data} />
  </CardActions>
)

const CreateActions = ({ basePath, data }) => (
  <CardActions>
    <ListButton basePath={basePath} record={data} />
  </CardActions>
)

const EditActions = ({ basePath, data }) => (
  <CardActions>
    <ListButton basePath={basePath} record={data} />
    <CreateButton basePath={basePath} record={data} />
    <GeneratePromoCodesAction record={data} />
  </CardActions>
)

const PromoCode = {
  filter: (props) => (
    <Filter {...props}>
      <SearchInput label='Search by code' source='code' alwaysOn />
      <ReferenceInput
        source='appId'
        reference='app'
        allowEmpty
        filterToQuery={searchText => ({ name: {$regex: searchText} })}
      >
        <AutocompleteInput optionText='name' translateChoice={false} />
      </ReferenceInput>
      <ReferenceInput
        source='activatedByUserId'
        reference='user'
        allowEmpty
        filterToQuery={searchText => ({ username: {$regex: searchText, $options: 'i'} })}
      >
        <AutocompleteInput optionText='username' translateChoice={false} />
      </ReferenceInput>
      <DateInput
        source='createdAt'
        label='Created after'
        parse={v => ({
          $gt: v
        })}
      />
      <DateInput
        source='createdAt'
        label='Created before'
        parse={v => ({
          $lt: v
        })}
      />
    </Filter>
  ),
  create: (props) => (
    <Create {...props} actions={<CreateActions />}>
      <SimpleForm>
        <ReferenceInput
          label='App'
          source='appId'
          reference='app'
          allowEmpty
          validate={required()}
          filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
        >
          <AutocompleteInput optionText='name' translateChoice={false} />
        </ReferenceInput>
        <TextInput
          source='code'
          helperText='Do not set if you want the code to be generated aromatically'
        />
      </SimpleForm>
    </Create>
  ),
  edit: (props) => {
    return (
      <Edit actions={<EditActions />}{...props}>
        <SimpleForm>
          <TextField label='id' source='id' />
          <TextInput source='code' label='Code' />
          <ReferenceInput
            label='App'
            source='appId'
            reference='app'
            allowEmpty
            validate={required()}
            filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
          >
            <AutocompleteInput optionText='name' translateChoice={false} />
          </ReferenceInput>

          <ReferenceInput
            source='activatedByUserId'
            reference='user'
            allowEmpty
            filterToQuery={searchText => ({ username: {$regex: searchText, $options: 'i'} })}
          >
            <AutocompleteInput optionText='username' translateChoice={false} />
          </ReferenceInput>
          <DateTimeInput source='activationDate' />
          <DateField source='createdAt' showTime />
          <DateField source='updatedAt' showTime />
        </SimpleForm>
      </Edit>
    )
  },
  list: (props) => (
    <List filters={<PromoCode.filter />} actions={<ListActions />} {...props}>
      <Datagrid
        rowClick='edit'
      >
        <TextField source='code' label='Code' />
        <ReferenceField source='appId' reference='app' allowEmpty>
          <TextField source='name' />
        </ReferenceField>
        <ReferenceField source='activatedByUserId' reference='user' allowEmpty>
          <TextField source='username' />
        </ReferenceField>
        <DateField source='activationDate' />
        <DateField source='createdAt' />
        <DateField source='updatedAt' />
      </Datagrid>
    </List>
  )
}

export default PromoCode
